import { render } from "./CrudPatients.vue?vue&type=template&id=7883ddaf&scoped=true"
import script from "./CrudPatients.vue?vue&type=script&lang=js"
export * from "./CrudPatients.vue?vue&type=script&lang=js"

import "./CrudPatients.vue?vue&type=style&index=0&id=7883ddaf&lang=css"
import "./CrudPatients.vue?vue&type=style&index=1&id=7883ddaf&scoped=true&lang=postcss"
import "./CrudPatients.vue?vue&type=style&index=2&id=7883ddaf&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7883ddaf"]])

export default __exports__